<template>
  　　　　　　　　　　　　<el-table :data="CreditUnclearOutlineList"
            border
            style="width: 100%"
            ref="table">
    <el-table-column align="center"
                     prop="name"
                     label="名称"
                     width="150">
    </el-table-column>
    <el-table-column align="center"
                     label="正常"
                     v-if="true">
      <el-table-column align="center"
                       sortable
                       prop="normalB"
                       label="笔数"
                       v-if="true">
        <template slot-scope="scope">
          <span>
            <el-input style="width: 90px"
                      placeholder="笔数"
                      v-model="scope.row.normalB"
                      class="table_input normalB_input"
                      @keyup.native="show($event,scope.$index)"></el-input>
            <!-- @change="handleCreditChange()" -->
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column align="center"
                       sortable
                       prop="normalY"
                       label="余额(万元)">
        <template scope="scope">
          <span>
            <el-input style="width: 90px"
                      placeholder="余额"
                      v-model="scope.row.normalY"
                      class="table_input normalY_input"
                      @keyup.native="show($event,scope.$index)"></el-input>
          </span>
        </template>
      </el-table-column> -->
    </el-table-column>
    <!-- <el-table-column align="center"
                     label="关注">
      <el-table-column align="center"
                       sortable
                       prop="focusB"
                       label="笔数">
        <template scope="scope">
          <span>
            <el-input style="width: 90px"
                      placeholder="笔数"
                      v-model="scope.row.focusB"
                      class="table_input focusB_input"
                      @keyup.native="show($event,scope.$index)"></el-input>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center"
                       sortable
                       prop="focusY"
                       label="余额(万元)">
        <template scope="scope">
          <span>
            <el-input style="width: 90px"
                      placeholder="余额"
                      v-model="scope.row.focusY"
                      class="table_input focusY_input"
                      @keyup.native="show($event,scope.$index)"></el-input>
          </span>
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column align="center"
                     label="不良">
      <el-table-column align="center"
                       sortable
                       prop="badB"
                       label="笔数">
        <template scope="scope">
          <span>
            <el-input style="width: 90px"
                      placeholder="笔数"
                      v-model="scope.row.badB"
                      class="table_input badB_input"
                      @keyup.native="show($event,scope.$index)"></el-input>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center"
                       sortable
                       prop="badY"
                       label="余额(万元)">
        <template scope="scope">
          <span>
            <el-input style="width: 90px"
                      placeholder="余额"
                      v-model="scope.row.badY"
                      class="table_input badY_input"
                      @keyup.native="show($event,scope.$index)"></el-input>
          </span>
        </template>
      </el-table-column>
    </el-table-column>
    <el-table-column align="center"
                     prop="amountY"
                     sortable
                     label="余额(万元)">
      <template scope="scope">
        <span>{{scope.row.amountY}}</span>
      </template>
    </el-table-column> -->
  </el-table>
</template>
<script>
import testApi from "@/api/api-test";
export default {
  data () {
    return {
      CreditUnclearOutlineList: [{ name: '111', normalB: 1, normalY: 2, focusB: 2, focusY: 2, badB: 1, badY: 2, amountY: 0 },
      { name: '111', normalB: 1, normalY: 2, focusB: 2, focusY: 2, badB: 1, badY: 2, amountY: 0 }]
    }
  },
  mounted () { },
  methods: {
    getTest () {
      let data = [];
      testApi.getMemberSignRecordList(data).then(
        res => { },
        err => {
          // "获取消费记录失败！"
        }
      );
    },
    //键盘触发事件
    show (ev, index) {

      let newIndex = index;

      //通过ev 获取 当前input 名称 用于判断属于哪列
      let clssName = ev.target.offsetParent.className;
      //获取每一列的input名称
      let normalB_input = document.getElementsByClassName('normalB_input')
      //获取54个input
      let inputAll = document.querySelectorAll('.table_input input');

      //向上 =38
      if (ev.keyCode == 38) {
        //当焦点在第一行的时候 按向上的时候焦点要聚焦到前一列的最后一个
        // if (newIndex >= 1 && newIndex <= 5) {
        //   newIndex = newIndex + 47;
        // } else {
        //   newIndex -= 6;
        // }

        newIndex -= 1
        if (inputAll[newIndex]) {

          inputAll[newIndex].focus();
          inputAll[newIndex].select();
        }

      }

      //下 = 40
      if (ev.keyCode == 40) {

        //当newIndex 在最后一行的时候 焦点要聚焦到 下一列的第一个
        // if (newIndex >= 48 && newIndex < 53) {

        //   newIndex = (newIndex % 8) + 1
        // } else {
        //   newIndex += 6;
        // }

        newIndex += 1
        if (inputAll[newIndex]) {

          inputAll[newIndex].focus();
          inputAll[newIndex].select();
        }

      }

    }
  }
};
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/view/test.vue